





























import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import BlackListItem from "./Item.vue";
import { BlackListDto } from "@/store/blacklists/blacklist.interface";
import BlackList from "@/store/blacklists";
import SearchBar from "./SearchBar.vue";

interface UpdatedItemPayload {
  item: BlackListDto;
  index: number;
}

@Component({
  components: {
    "blacklist-item": BlackListItem,
    "search-bar": SearchBar
  }
})
export default class AppBlackListItem extends Vue {
  page: number = 1;
  data: BlackListDto[] = [];
  query: string = "";
  async infiniteHandler($state: any) {
    this.search($state);
  }

  async search($state: any) {
    try {
      const res = await BlackList.api().fetch({
        params: {
          page: this.page,
          keywords: this.query,
          order: "id||DESC"
        }
      });

      const blacklists = res.response.data.data;

      if (blacklists.length) {
        this.data.push(...blacklists);
        this.page += 1;
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    } catch (error) {}
  }

  async onSearch(query: string) {
    this.page = 1;
    this.data = [];
    this.query = query;
    this.search(null);
  }

  mounted() {
    this.sockets.subscribe("blacklistAdded", (data: any) => {
      this.onSearch(this.query);
    });
  }

  destroyed() {
    this.sockets.unsubscribe("blacklistAdded");
  }

  onUpdatedItem(input: UpdatedItemPayload) {
    this.data = [
      ...this.data.slice(0, input.index),
      {
        ...(input.item as any)
      },
      ...this.data.slice(input.index + 1, this.data.length)
    ];
  }

  async goTo(item: BlackListDto) {
  }
}
